<template>
  <div>
    <div class="flex_box">
      <div class="flex_check_box"><cx-check-box :value.sync="showHot">区域热力层</cx-check-box></div>
      <div @click="changeSeriesType('cxMap3DHot')"><span class="flex_icon icon-portal-edit-1"></span></div>
    </div>
    <div class="flex_box mt16">
      <div class="flex_check_box"><cx-check-box :value.sync="showBar">单点柱状层</cx-check-box></div>
      <div @click="changeSeriesType('cxMap3DBar')"><span class="flex_icon icon-portal-edit-1"></span></div>
    </div>
    <div class="flex_box mt16">
      <div class="flex_check_box"><cx-check-box :value.sync="showLines">飞线层</cx-check-box></div>
      <div @click="changeSeriesType('cxMap3DLines')"><span class="flex_icon icon-portal-edit-1"></span></div>
    </div>
    <div class="flex_box mt16">
      <div class="flex_check_box"><cx-check-box :value.sync="showScatter">散点图/气泡层</cx-check-box></div>
      <div @click="changeSeriesType('cxMap3DScatter')"><span class="flex_icon icon-portal-edit-1"></span></div>
    </div>
  </div>
</template>

<script>
export default {
  props: { options: Object },
  computed: {
    chartOption() {
      return this.options.chartOption
    },
    showScatter: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "showScatter", "showScatter", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.showScatter", false)
      }
    },
    showHot: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "showHot", "showHot", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.showHot", false)
        this.$changeOptionsEV(newVal, "chartOption.visualMap.show", false)
      }
    },
    showLines: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "showLines", "showLines", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.showLines", false)
      }
    },
    showBar: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "showBar", "showBar", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.showBar", false)
      }
    }
  },
  methods: {
    changeSeriesType(type) {
      this.$store.commit("states/changeElementType", type)
    }
  }
}
</script>

<style scoped>
.flex_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}
.flex_icon {
  vertical-align: middle;
}
.flex_icon:hover {
  cursor: pointer;
}
.flex_check_box {
  width: 60%;
}
</style>
